import * as React from 'react';
import Carousel from './../Carousel';
import './CarouselContainer.scss';

interface ICarouselContainerProps {
  loading: boolean;
  children: any;
}

export function CarouselContainer(props: ICarouselContainerProps) {
  return (
    <div className="rp-carousel-container">
      {props.loading ? (
        <div className="loader-container">
          <div className="loader" />
        </div>
      ) : (
        <Carousel
          responsive={{
            560: {
              items: 1,
              showArrows: true,
              singleitemPercentage: 100,
              mobileException: true
            },
            767: {
              items: 2,
              showArrows: true,
              singleitemPercentage: 50,
              mobileException: false
            },
            950: {
              items: 3,
              showArrows: true,
              singleitemPercentage: 33,
              mobileException: false
            },
            1270: {
              items: 4,
              showArrows: true,
              singleitemPercentage: 25,
              mobileException: false
            },
            1300: {
              items: 5,
              showArrows: true,
              singleitemPercentage: 25,
              mobileException: false
            },
            2000: {
              items: 5,
              showArrows: true,
              singleitemPercentage: 20,
              mobileException: false
            },
            3000: {
              items: 5,
              showArrows: true,
              singleitemPercentage: 20,
              mobileException: false
            }
          }}
        >
          {props.children}
        </Carousel>
      )}
    </div>
  );
}
